module.exports = __webpack_public_path__ + "images/wwvoertuigen1580b6f7cf26a231e688e9ac28af219b.png";